module.exports = __webpack_public_path__ + "media/src/images/favicons/mstile-310x150-ecb27c7ab2b909b8451703810fcfdff5.png";